export default __webpack_public_path__ + "static/media/brand_names_mob.74c4c9fc.png";